import * as angular from "angular";

angular
  .module('bringoz.admin.tasks', [
    // 'ngMaterialDatePicker',
    'bringoz.admin.accounts'
  ]);
